import { render, staticRenderFns } from "./BaseStrong.vue?vue&type=template&id=54df7f0c&"
import script from "./BaseStrong.vue?vue&type=script&lang=ts&"
export * from "./BaseStrong.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports